import './style.scss'
import React from 'react'
const SignInWrapper = ({ children }) => {
  return <div className="signin-wrapper">{children}</div>
}
export default SignInWrapper
